import BaseModule from "~/vuex/modules/base-module";

let enquiryBrochures = {...BaseModule};

enquiryBrochures.state = function () {
    let state = BaseModule.state();

    state.lastDate = null;
    state.sort = {};

    return state;
};



export default enquiryBrochures;
